export const BOOKING_OUTCOME_COLORS = {
  completed: '#86EFAC',
  noShow: '#FCD34D',
  cancelled: '#FCA5A5',
} as const

export type BookingOutcomeChartData = {
  accepted: number
  noShow: number
  cancelled: number
  total: number
}

export const EMPTY_BOOKING_OUTCOME_DATA: BookingOutcomeChartData = {
  accepted: 0,
  noShow: 0,
  cancelled: 0,
  total: 0,
}
